
import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { mapGetters } from 'vuex'
import { setupTranslationPrefixer } from '~/assets/translation'
import { linkDetails } from '@/assets/link'

export default defineComponent({
  setup() {
    return {
      ...setupTranslationPrefixer('footer'),
    }
  },
  computed: {
    ...mapGetters({
      footer: 'navigation/footer',
      footerService: 'navigation/footerService',
    }),
    locale() {
      return this.$i18n.locale
    },
  },
  methods: {
    isExternal(url) {
      const { req } = useContext()
      const currentHost = `//${req?.headers.host || window?.location.host}`
      const { scope } = linkDetails(currentHost, url)

      return scope === 'outside'
    },
  },
})
